import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import Image, { StaticImageData } from 'next/image'
import {
  ExploreRoot,
  RecipesContainer,
  RecipesWrapper,
  WfrWrapper,
  TitleWrapper,
  RecipeBadge,
  BorderWrapper,
} from './Explore.styles'
import wfr from '../../../../../../public/assets/recipes/categories/individual/explore-icon.png'
import chickenIcon from '../../../../../../public/assets/recipes/categories/individual/chicken-icon.png'
import cowIcon from '../../../../../../public/assets/recipes/categories/individual/cow-icon.png'
import deerIcon from '../../../../../../public/assets/recipes/categories/individual/deer-icon.png'
import turkeyIcon from '../../../../../../public/assets/recipes/categories/individual/turkey-icon.png'
import duckIcon from '../../../../../../public/assets/recipes/categories/individual/duck-icon.png'
import lambIcon from '../../../../../../public/assets/recipes/categories/individual/lamb-icon.png'
import { SectionTitle } from '../styles'
import { RecipePill } from '../../../components/SixRecipes/SixRecipes'
import { Stack } from 'components/Stack'
import { RecipeType } from '../../../types'
import Link from 'next/link'
import { BorderWave } from 'components/BorderWave'

type RecipeItem = {
  name: RecipeType
  badge: StaticImageData
  label: string
  icon: 'chicken' | 'deer' | 'cow' | 'lamb' | 'turkey' | 'duck'
}

export const Explore = ({ hide }: { hide: RecipeType }) => {
  const { t } = useTranslation()

  const RecipeList: RecipeItem[] = [
    {
      name: 'chicken',
      badge: chickenIcon,
      label: t('recipes:overview.six-recipes.recipe-1'),
      icon: 'chicken',
    },
    {
      name: 'beef',
      badge: cowIcon,
      label: t('recipes:overview.six-recipes.recipe-2'),
      icon: 'cow',
    },
    {
      name: 'lamb',
      badge: lambIcon,
      label: t('recipes:overview.six-recipes.recipe-3'),
      icon: 'lamb',
    },
    {
      name: 'turkey',
      badge: turkeyIcon,
      label: t('recipes:overview.six-recipes.recipe-4'),
      icon: 'turkey',
    },
    {
      name: 'venison',
      badge: deerIcon,
      label: t('recipes:overview.six-recipes.recipe-5'),
      icon: 'deer',
    },
    {
      name: 'duck',
      badge: duckIcon,
      label: t('recipes:overview.six-recipes.recipe-6'),
      icon: 'duck',
    },
  ]

  return (
    <>
      <BorderWrapper>
        <BorderWave
          background="secondary-150"
          svgHeight="78px"
          invert
          svgWidth="calc(144% + 1.3px)"
          path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
        />
        <WfrWrapper>
          <Image src={wfr} alt="" />
        </WfrWrapper>
      </BorderWrapper>
      
      <ExploreRoot>
     
        {/* <WaveWrapper>
        <Image src={wave} alt="" />
        <WfrWrapper>
          <Image src={wfr} alt="" />
        </WfrWrapper>
      </WaveWrapper> */}
        <RecipesWrapper>
          <TitleWrapper>
            <SectionTitle>{t('recipes:individual.explore')}</SectionTitle>
          </TitleWrapper>
          <RecipesContainer>
            {RecipeList.map((recipe) => {
              if (recipe.name !== hide) {
                return (
                  <Stack
                    key={recipe.name}
                    direction="column"
                    alignItems="center"
                    gap={{ '@initial': '2', '@bp2': '4' }}
                  >
                    <Link href={`/recipes/${recipe.name}`}>
                      <RecipeBadge>
                        <Image src={recipe.badge} alt={recipe.label} />
                      </RecipeBadge>
                    </Link>
                    <RecipePill large icon={recipe.icon} recipe={recipe.name}>
                      {recipe.label}
                    </RecipePill>
                  </Stack>
                )
              }
              return null
            })}
          </RecipesContainer>
        </RecipesWrapper>
      </ExploreRoot>
    </>
  )
}

Explore.displayName = 'Explore'
